import BaseRoute from 'seshy/routes/base';

export default class AuthenticatedProjectsShowProjectVersionsShowBouncesIndexRoute extends BaseRoute {}
